import React from 'react';

// Submitted documents for review: one row per document with its status and
// a "View" link (a short-lived signed link created by the server — the files
// themselves are never public). Accepts both document shapes the backend
// returns: provider documents ({ label, uploaded, url }) and user documents
// ({ label, file_path, signed_url | url }).
export default function DocumentList({ documents, emptyText = 'No documents submitted.' }) {
  if (!documents || documents.length === 0) return <p style={s.empty}>{emptyText}</p>;
  return (
    <ul style={s.list}>
      {documents.map((d, i) => {
        const url = d.url || d.signed_url || null;
        const uploaded = d.uploaded !== undefined ? d.uploaded : !!(d.file_path || url);
        return (
          <li key={`${d.document_type || d.label}-${i}`} style={s.item}>
            <div style={s.main}>
              <span style={s.label}>{d.label || d.name || d.document_type}</span>
              {d.required && <span style={s.required}>required</span>}
              {d.expiry_date && <span style={s.meta}>expires {new Date(d.expiry_date).toLocaleDateString()}</span>}
            </div>
            <div style={s.side}>
              {uploaded ? <span style={{ ...s.badge, ...s.ok }}>Uploaded</span> : <span style={{ ...s.badge, ...s.missing }}>Missing</span>}
              {url ? (
                <a href={url} target="_blank" rel="noopener noreferrer" style={s.view}>View</a>
              ) : uploaded ? <span style={s.meta}>no preview</span> : null}
            </div>
          </li>
        );
      })}
    </ul>
  );
}

const s = {
  empty: { color: '#64748b', fontSize: 13, margin: 0 },
  list: { listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 6 },
  item: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap',
    padding: '8px 10px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8,
  },
  main: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', minWidth: 0 },
  label: { fontSize: 13.5, fontWeight: 600, color: '#0f172a' },
  required: { fontSize: 10.5, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em' },
  meta: { fontSize: 12, color: '#64748b' },
  side: { display: 'flex', alignItems: 'center', gap: 8 },
  badge: { fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 999 },
  ok: { background: '#dcfce7', color: '#166534' },
  missing: { background: '#fee2e2', color: '#991b1b' },
  view: {
    fontSize: 12.5, fontWeight: 700, color: '#0B6A4A', textDecoration: 'none', padding: '5px 10px',
    border: '1px solid #a7f3d0', borderRadius: 6, background: '#ecfdf5',
  },
};
